import { useMutation } from "react-query";
import { MutationConfig, queryClient } from "../../../../../lib/react-query";
import { apiEmpleo } from "../../../../../util/ApiEmpleo";
import { TCandidateAttachment } from "../types/candidateAttachment.types";
import { candidateAttachmentKeys } from "./candidateAttachments.query-keys";

export type TApiUploadCandidateAttachmentPayload = {
  candidateId: string;
  file: File;
};

export const apiUploadCandidateAttachment = async (
  payload: TApiUploadCandidateAttachmentPayload
) => {
  const form = new FormData();
  form.append("file", payload.file);

  const res: TCandidateAttachment = await apiEmpleo.post(
    `candidatos/${payload.candidateId}/attachments`,
    form,
    {
      headers: {
        "content-type": `multipart/form-data; boundary=${
          (form as any)._boundary
        }`,
      },
    }
  );

  return res;
};

type TUseUploadCandidateAttachmentOptions = {
  config?: MutationConfig<typeof apiUploadCandidateAttachment>;
};

export const useUploadCandidateAttachment = ({
  config,
}: TUseUploadCandidateAttachmentOptions = {}) => {
  return useMutation({
    onSettled: () => {
      queryClient.invalidateQueries(candidateAttachmentKeys.all);
    },
    ...config,
    mutationFn: apiUploadCandidateAttachment,
  });
};
